/**
 * What the desktop's menu bar (docs/refactor/46) asks of screens it does not own: the Editor's Abrir/Salvar/Localizar
 * and the sidebar's Abrir projeto / Adicionar pasta. Each screen keeps doing it its own way; the menu only asks.
 */

export type EditorCommand = 'open' | 'save' | 'saveAs' | 'find'
export type ProjectCommand = 'open' | 'addFolder'

export const EDITOR_COMMAND_EVENT = 'devpulse:editor-command'
export const PROJECT_COMMAND_EVENT = 'devpulse:project-command'

let pendingEditor: EditorCommand | null = null

/** Asks the Editor for `command`: now if it is on screen, or as soon as it opens (Abrir arquivo from anywhere). */
export function editorCommand(command: EditorCommand): void {
  pendingEditor = command
  window.dispatchEvent(new CustomEvent<EditorCommand>(EDITOR_COMMAND_EVENT, { detail: command }))
}

/** The command waiting for the Editor, once: taking it clears it. */
export function takeEditorCommand(): EditorCommand | null {
  const command = pendingEditor
  pendingEditor = null
  return command
}

export function projectCommand(command: ProjectCommand): void {
  window.dispatchEvent(new CustomEvent<ProjectCommand>(PROJECT_COMMAND_EVENT, { detail: command }))
}
